export const productReviewRatingsMetadata = /* GraphQL */ `
    query {
        productReviewRatingsMetadata {
            items {
                id
                name
                values {
                    value_id
                    value
                }
            }
        }
    }
`
